import { render, staticRenderFns } from "./ceshi.vue?vue&type=template&id=2f2a1b5c&scoped=true&"
import script from "./ceshi.vue?vue&type=script&lang=js&"
export * from "./ceshi.vue?vue&type=script&lang=js&"
import style0 from "./ceshi.vue?vue&type=style&index=0&id=2f2a1b5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a1b5c",
  null
  
)

export default component.exports